var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTraduction(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.625 0.625V48.4375H16.5625V64.375H64.375V16.5625H48.4375V0.625H0.625ZM5.9375 5.9375H43.125V18.058L18.0553 43.125H5.9375V5.9375ZM19.2188 11.25V13.9062H11.25V19.2188H24.3666C24.0212 22.2734 23.0863 24.6747 21.543 26.3587C20.7039 26.0869 19.8969 25.7244 19.1364 25.2777C17.2664 24.1673 16.5598 22.9933 16.5598 21.8777H11.25C11.25 25.0439 13.1997 27.6736 15.8188 29.432C14.3138 29.7243 12.783 29.8622 11.25 29.8438V35.1562C15.9569 35.1562 19.8775 34.0805 22.8711 32.0856C24.263 32.3247 25.6681 32.5 27.1875 32.5V27.5195C28.6298 25.1023 29.4002 22.2787 29.6791 19.2188H32.5V13.9062H24.5312V11.25H19.2188ZM46.9447 21.875H59.0625V59.0625H21.875V46.942L46.9447 21.875ZM43.125 26.7731L40.6334 34.3275L35.3209 50.265L35.1562 50.6794V53.75H40.4688V51.4258L40.5484 51.0938H45.7016L45.7812 51.4258V53.75H51.0938V50.6794L50.9264 50.2623L45.6139 34.3248L43.125 26.7758V26.7731ZM43.125 43.4544L43.8688 45.7812H42.3812L43.125 43.457V43.4544Z",
    fill: "#EC5393"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTraduction);
export default __webpack_public_path__ + "static/media/traduction.36ab9b804099a57b8822896693ab4935.svg";
export { ForwardRef as ReactComponent };